import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import withPopover from 'shared/hocs/withPopover';

import { cancelAppointment } from 'modules/appointmentInfo/actions/cancelAppointment';
import { canCloseAppointment, getCloseAppointmentPermissions } from 'modules/appointmentInfo/selectors/currentAppointment';
import { replaceTo } from 'modules/auth/actions/redirectAction';
import { conferenceInProgressWithSIP, isInWaitingRoom } from 'modules/conference/selectors/consultationInfo';

import DropdownMenu from './DropdownMenu';

const mapStateToProps = (state) => {
  const canCloseCurrentAppointment = canCloseAppointment(state);
  const { hasCancelPermission, canUpdateAppointment } = getCloseAppointmentPermissions(state);

  return {
    canCloseCurrentAppointment,
    hasCancelPermission,
    canUpdateAppointment,
    appointmentId: state.appointmentInfo.currentAppointment.appointmentId,
    userIsOnCall: conferenceInProgressWithSIP(state) || isInWaitingRoom(state),
  };
};


export default compose(
  withPopover(),

  connect(
    mapStateToProps,
    { cancelAppointment },
  ),

  withHandlers({
    editAppointmentDetails: ({ appointmentId }) => () => {
      replaceTo(`/appointment/update/${ appointmentId }`);
    },
  }),
)(DropdownMenu);
